import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../../utils";
import { Info } from "../icons";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, } from "./Tooltip";
export const HelpTooltip = props => {
    const { children, size, className } = props;
    return (_jsx(TooltipProvider, { children: _jsxs(Tooltip, { children: [_jsx(TooltipTrigger, { asChild: true, children: _jsx("button", { type: "button", className: cn("inline ml-1 leading-none align-middle", className), children: _jsx(Info, { size: size }) }) }), _jsx(TooltipContent, { children: children })] }) }));
};
